export const resourceStatus = state => state.resourceStatus;
